import { ReactNode, useCallback } from 'react';
import { useController } from 'react-hook-form';
import { useFieldStateError } from './useFieldStateError';
import { Box, FormHelperText, Tabs } from '@mui/material';

export function TabsField({
  name,
  label,
  defaultValue,
  required,
  disabled,
  children,
}: {
  name: string;
  label: ReactNode;
  defaultValue?: string;
  required?: boolean;
  disabled?: boolean;
  children: ReactNode;
}) {
  const { field, fieldState } = useController({
    name,
    disabled,
    defaultValue,
    rules: {
      required,
    },
  });

  const fieldError = useFieldStateError(label, fieldState.error);

  const handleChange = useCallback(
    (_: unknown, value: string) => {
      field.onChange(value);
    },
    [field],
  );

  return (
    <Box>
      <Tabs value={field.value ?? null} onChange={handleChange} onBlur={field.onBlur}>
        {children}
      </Tabs>
      {fieldError ? <FormHelperText error>{fieldError}</FormHelperText> : null}
    </Box>
  );
}
